// extracted by mini-css-extract-plugin
export var modalContainer = "LoadingModal-module--modalContainer--7P1Bt";
export var modalContent = "LoadingModal-module--modalContent--HlzZd";
export var content = "LoadingModal-module--content--TPMIz";